module.exports = __webpack_public_path__ + "static/img/bulk-upload@2x.786c915d.png";